import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 32C26.6274 32 32 26.6274 32 20C32 13.3726 26.6274 8 20 8C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32Z",
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.2 20H20L24.8 15.2",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgClock);
export default ForwardRef;
